import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link, Navigate } from 'react-router-dom';
import { AdminAuthProvider } from './contexts/AdminAuthContext';
import Home from './pages/Home';
import TutorDirectory from './pages/TutorDirectory';
import StMarysDirectory from './pages/StMarysDirectory';
import RedondoDirectory from './pages/RedondoDirectory';
import CostaMentorDirectory from './pages/CostaMentorDirectory';
import WillRogerDirectory from './pages/WillRogerDirectory';
import SMCDirectory from './pages/SMCDirectory';
import TutorProfile from './pages/TutorProfile';
import Register from './pages/Register';
import TutorRegister from './pages/TutorRegister';
import TutorRegisterSMC from './pages/TutorRegisterSMC';
import EmailVerify from './pages/EmailVerify';
import AdminDashboard from './pages/AdminDashboard';
import AdminLogin from './pages/AdminLogin';
import About from './pages/About';
import Header from './components/Header';
import Footer from './components/Footer';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfUse from './pages/TermsOfUse';

function App() {
  return (
    <AdminAuthProvider>
     <Router>
        <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/mb" element={<Navigate to="/directory" replace />} />
            <Route path="/ja" element={<Navigate to="/directory/ja" replace />} />
            <Route path="/rb" element={<Navigate to="/directory/rb" replace />} />
            <Route path="/wr" element={<Navigate to="/directory/wr" replace />} />
            <Route path="/smc" element={<Navigate to="/directory/smc" replace />} />
            <Route path="/directory" element={<TutorDirectory />} />
            <Route path="/directory/ja" element={<StMarysDirectory />} />
            <Route path="/directory/rb" element={<RedondoDirectory />} />
            <Route path="/directory/wr" element={<WillRogerDirectory />} />
            <Route path="/directory/smc" element={<SMCDirectory />} />
            <Route path="/directory/MBMentor" element={<CostaMentorDirectory />} />
            <Route path="/tutor/:id" element={<TutorProfile />} />
            <Route path="/register" element={<Register />} />
            <Route path="/tutor-register" element={<TutorRegister />} />
            <Route path="/tutor-register-smc" element={<TutorRegisterSMC />} />
            <Route path="/about" element={<About />} />
            <Route path="/verify-email" element={<EmailVerify />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminDashboard />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms-of-use" element={<TermsOfUse />} />
          </Routes>
          <Footer />
        </div>
      </Router>
    </AdminAuthProvider>
  );
}

export default App;
